import { render, staticRenderFns } from "./AddCategory.vue?vue&type=template&id=698dd192&scoped=true"
import script from "../../script/add-category.js?vue&type=script&lang=js&external"
export * from "../../script/add-category.js?vue&type=script&lang=js&external"
import style1 from "./AddCategory.vue?vue&type=style&index=1&id=698dd192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698dd192",
  null
  
)

export default component.exports